<template>
  <refapp-video-base>
    <template #controls="{ togglePlayback, toggleAudio }">
      <refapp-video-controls @playback="togglePlayback" @audio="toggleAudio" />
    </template>
    <template #content>
      <refapp-video-content><slot></slot></refapp-video-content>
    </template>
  </refapp-video-base>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import RefappVideoContent from './base/content.vue';
import RefappVideoControls from './base/controls.vue';
import RefappVideoBase from './base/video.vue';

export default {
  name: 'refapp-video',
  components: {
    RefappVideoControls,
    RefappVideoContent,
    RefappVideoBase,
  },
};
</script>
<style lang="scss">
@use '../styles/entry.scss';
</style>
